"use strict";

var _ = require('lodash');

var responsiveCompositesDefinition = require('./compositeDefinitions');

var compositeFactory = require('../composites/compositeFactory');

var ResponsiveComposites = _.mapValues(responsiveCompositesDefinition, function (v) {
  return compositeFactory(v);
});

module.exports = ResponsiveComposites;